const createReferalLink = (refLink: string, tenantID: number) => {
	return `${refLink}${tenantID}`;
}

export {
	createReferalLink,
};
